import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getProductTreeList, queryWareHouseList } from '@/api/api';
import Vue from 'vue';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { downloadFile } from '@/api/manage';
export default {
  name: 'DevicesWarningWarrantyList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {},
  data: function data() {
    return {
      autoLoadInit: false,
      pageTitle: '质保提醒',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '设备编号',
        align: 'center',
        dataIndex: 'assetCode',
        scopedSlots: {
          customRender: 'assetCode'
        }
      }, {
        title: '出厂编号',
        align: 'center',
        dataIndex: 'sn',
        scopedSlots: {
          customRender: 'sn'
        }
      }, {
        title: '产品名称',
        align: 'center',
        dataIndex: 'productName'
      }, // {
      //   title: '产品类别',
      //   align: 'center',
      //   dataIndex: 'productCategoryName',
      // },
      {
        title: '供应商',
        align: 'center',
        dataIndex: 'companyName'
      }, {
        title: '规格型号',
        align: 'center',
        dataIndex: 'model'
      }, {
        title: '质保结束日期',
        align: 'center',
        dataIndex: 'warrantyEnd'
      }, {
        title: '距离到期天数',
        align: 'center',
        dataIndex: 'warrantyDiff'
      }],
      url: {
        list: '/ea/asset/info/warning/Warranty',
        exportXlsUrl: '/ea/asset/info/warningExportXls'
      },
      productTree: [],
      whList: [],
      queryParam: {}
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.spliceColumn(this.siteColumn);
      } else {
        this.spliceColumn(this.siteColumn, 1);
      }

      this.loadData();
    }
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  created: function created() {
    this.loadCategory();
  },
  methods: {
    loadCategory: function loadCategory() {
      var that = this;
      var params = {
        parent: 1
      };
      getProductTreeList(params).then(function (res) {
        if (res.success) {
          that.treeData = res.result;
        }
      });
    },
    handleExportXls: function handleExportXls(fileName) {
      if (!fileName || typeof fileName != 'string') {
        fileName = this.pageTitle + '导出文件';
      }

      var param = _objectSpread({}, this.queryParam);

      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param['selections'] = this.selectedRowKeys.join(',');
      }

      var url = this.url && this.url.exportXlsUrl ? this.url.exportXlsUrl : this.pagePath + '/warningExportXls';
      downloadFile(fileName + '.xls', url, param);
    }
  }
};